import React from "react";
import Header from "./components/PublicDocsNavbar";
import Content from "./components/TermsAndConditions";
import Footer from "./components/PublicDocsFooter";

function TermsOfUse() {
  return (
    <div className="wrap-ppolicy">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}

export default TermsOfUse;
